import { getCurrencyCodeByCountry } from "@features/country/data";
import {
  OrderModel,
  OrderProductModel,
  OrdersListModel,
} from "@features/orders/data";
import {
  OrderEntity,
  OrderLineEntity,
  OrderProductEntity,
} from "@features/orders/domain";
import { OrdersListEntity } from "./../../domain/entities/order.entity";

function mapOrderProduct(product: OrderProductModel): OrderProductEntity {
  return {
    name: product?.name,
    price: product?.productPrice,
    quantity: product?.productQty,
    profit: product?.productProfit,
    productId: product?.productObjectId,
  };
}

function mapOrderLines(order: OrderModel): OrderLineEntity[] {
  const orderLines = order.orderLines || [
    mapOrderProduct((order as any).product),
  ];

  return orderLines as OrderLineEntity[];
}

export function mapOrdersList(
  data: OrdersListModel,
  pageSize: number,
  type: OrderEntity["type"],
): OrdersListEntity {
  return {
    hasNextPage: data?.orders?.length >= pageSize,
    count: data?.orders?.length,
    orders: data?.orders?.map(order => ({
      ...order,
      id: order.orderID || order.orderId,
      orderLines: mapOrderLines(order),
      type,
      currency: getCurrencyCodeByCountry(order.country),
      totalQuantity: order?.product?.productQty,
      returnFee: order.returnShippingCost,
      integrationOrderId: order.integrationOrderId || order.pOrderIntegrationId,
      confirmationFailedAttempts: order.confirmationFailedAttempts?.map(
        attempt => ({
          ...attempt,
          date: attempt.date ? new Date(attempt.date) : undefined,
        }),
      ),
      failedAttemptsCount:
        order.failedAttemptsCount ||
        order.confirmationFailedAttempts?.length ||
        0,
    })) as OrderEntity[], // For now
  };
}

export function mapMerchantConfirmationOrder(
  data: any,
  pageSize: number,
  type: OrderEntity["type"],
): OrdersListEntity {
  return {
    hasNextPage: data?.data?.orders?.length >= pageSize,
    count: data?.data?.orders?.length,
    orders: data?.data?.orders?.map(order => ({
      ...order,
      id: order.orderID || order.orderId,
      orderLines: mapOrderLines(order),
      type,
      currency: getCurrencyCodeByCountry(order.country),
      totalQuantity: order?.product?.productQty,
      returnFee: order.returnShippingCost,
      integrationOrderId: order.integrationOrderId,
      confirmationFailedAttempts: order.confirmationFailedAttempts?.map(
        attempt => ({
          ...attempt,
          date: attempt.date ? new Date(attempt.date) : undefined,
        }),
      ),
      failedAttemptsCount:
        order.failedAttemptsCount ||
        order.confirmationFailedAttempts?.length ||
        0,
    })) as OrderEntity[], // For now
  };
}
